<template>
  <l-layout :layout="[ 'xs12']" bottom-space>
   <div v-if="hasPermission">
     <l-data-table
       :get-data-func="getItems"
       :headers="headers"
       title-text="高级预约列表"
       v-model="selected"
       search-text="搜索分组名称"
       @click:row="goDetails($event.item)"
       clickable
       selectable
       ref="dataTable"
       :filter-items="filter"
       :init-pagination="{sortBy:'status',descending:true}"
     >
       <template slot="title-action">
         <l-option-menu
           :options="moreActions"
         >
           <v-btn icon slot="activator">
             <v-icon>$vuetify.icons.more</v-icon>
           </v-btn>
         </l-option-menu>
       </template>
       <template slot="row-action" slot-scope="{item}">
         <td @click.stop class="px-0 mx-0 text-xs-center">
           <v-btn @click="deleteItem(item)" icon :disabled="item.status==='-1'">
             <v-icon small>$vuetify.icons.delete</v-icon>
           </v-btn>
         </td>
       </template>
     </l-data-table>
     <l-fixed-btn
       @click="goNew"
       icon="$vuetify.icons.add"
     ></l-fixed-btn>
   </div>
    <div v-else>
      {{errMsg}}
    </div>
  </l-layout>
</template>

<script>
import {PERSON_GROUP_ACTION_HEADERS, GROUP_HEADERS} from '../../../consts/reservation'
import {ReservationAuthority} from '../../../object'
import {time} from '../../../ladmin/utils'
export default {
  name: 'PersonReservationGroupList',
  props: ['refresh'],
  data: () => ({
    hasPermission:true,
    errMsg:'',
    selected: [],
    userSelect: [],
    floatingButton: false,
    showHistory: false,
    moreActions: [
      {
        event: 'delete',
        label: '批量删除',
        icon: '$vuetify.icons.deleteAll'
      },
      // {
      //   event: 'export',
      //   label: '导出PDF',
      //   icon: '$vuetify.icons.description'
      // }
    ],
    headers: PERSON_GROUP_ACTION_HEADERS,
    headersHistory: GROUP_HEADERS,
    filter: [
      {
        prependIcon: '$vuetify.icons.edit',
        key: 'status',
        value: '{"r_h_status":"1"}',
        label: '是否有效',
        type: 'select',
        layout: ['xs12', 'sm4'],
        items: [
          {
            value: '',
            text: '全部'
          },
          {
            value: '{"r_h_status":"1"}',
            text: '有效'
          },
          {
            value: '{"r_h_status":"-1"}',
            text: '失效'
          }],
      },
      {
        label: '过期时间',
        layout: 'xs12, sm4',
        type: 'duration',
        key: 'expirationTime',
        value: {},
        range: true,
        f: v => {
          if (!v.startDatetime && !v.endDatetime) {
            return null
          }
          else {
            // let s = v.startDatetime + ':00' || 0
            // let e = v.endDatetime + ':00' || 9999999999999
            let s = time.toTimeStamp(v.startDatetime) || 0
            let e = time.toTimeStamp(v.endDatetime) || 9999999999999
            return [s, e]
          }
        }
      },
    ]
  }),
  methods: {
    async getItems ({pagination, sortStack, filterItems, search}) {
      let {items, amount} = await this.$store.dispatch('personReservation/getPersonAdminReservations', {
        pagination,
        sortStack,
        filter: filterItems,
        search: {key: 'name', value: search},
      })
      let res = []
      for (let i in items) {
        let item = items[i]
        let j = JSON.parse(item.obgrp.rhdata) || {}
        let obj = {
          id: item.obgrp.id,
          name: item.obgrp.name,
          platePreview: item.platePreview,
          total: item.totalReg,
          host: (item.user===undefined)?"":item.user.name,
          phone: (item.user===undefined)?"":item.user.mobilePhone,
          creationTime: item.obgrp.creationTime,
          expirationTime: item.obgrp.expirationTime,
          status: j.r_h_status
        }
        //console.log(obj)
        res.push(obj)
      }
      return {items: res, amount: amount}
    },
    async getItemsHistory ({pagination, sortStack, filterItems, search}) {
      let {items, amount} = await this.$store.dispatch('personReservation/getReservationGroupsHistory', {
        pagination,
        sortStack,
        filter: filterItems,
        search: {key: 'name', value: search},
      })
      let res = []
      for (let i in items) {
        let item = items[i]
        let obj = {
          id: item.obgrp.id,
          name: item.obgrp.name,
          platePreview: item.platePreview,
          total: item.totalReg,
          host: item.user.name,
          phone: item.user.mobilePhone,
          creationTime: item.obgrp.creationTime,
          expirationTime: item.obgrp.expirationTime
        }
        console.log(obj)
        res.push(obj)
      }
      return {items: res, amount: amount}
    },
    async deleteItem (type) {
      // console.log(user)
      if (!type) return
      let {res, close} = await this.$L.confirm({
        title: '确认删除该分组？',
        text: type.name || `N/A`,
        subText: '删除该分组会导致该分组下的预约行人无法通行'
      })
      if (res) {
        try {
          await this.$store.dispatch('personReservation/deleteGroups', [type])
          this.$refs.dataTable.refresh()
          this.$L.alert('success', {message: '删除成功'})
        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
      }
      close()
    },
    goDetails (item, isHistory) {
      this.getReservationConfig()
      let selectionString = document.getSelection().toString()
      if (!selectionString) {
        this.$router.push({
          name: 'PersonReservationGroupDetails',
          params: {id: item.id},
          query: {id: item.id, status: item.status}
        })
      }
    },
    goNew () {
      this.getReservationConfig()
      this.$router.push({
        name: 'PersonNewGroupReservation',
        path: 'new',
        query: {
          status: 'new',
          id: ''
        }
      })
    },
    async getReservationConfig () {
      let res = await this.$store.dispatch('personReservationConfig/getReservationConfig', 'admin')
      console.log(res.data.data)
      if (res.data.status === 1) {
        let object = new ReservationAuthority({
          name: '高级预约',
          maxVehicleAmount: 1000,
          maxStartDay: -1,
          maxDurationDay: res.data.data.maxDurDays,
          presetCtrls: res.data.data.presetCtrls,
          type: ['sectional', 'day', 'week'],

          // 是否可以定义分组名称和描述
          editGroupInfo: true,

          // 是否可定义特殊进出场提示
          editPrompt: true
        })
        // console.log(object)
        this.$store.commit('personReservation/setAdminAuth', object)
      }
      else {
        this.hasPermission = false
        this.errMsg = res.data.msg
        //this.$L.alert('error', {message: '查询预约配置失败，原因：' + res.data.msg})
      }
    },
    async getHosts (param) {
      let search = (param === undefined) ? '' : param.target.value
      let pagination = {page: 0, rowsPerPage: 10}
      let searchParam = {
        'searchParam': {
          'loginId': {
            'index': '1',
            'order': 'DESC',
            'operators': [
              {
                'keyword': search,
                'operator': 'LIKE',
                'matchType': 'BOTH'
              }
            ]
          }
        }
      }
      let res = await this.$store.dispatch('personReservationConfig/getUsers', {param: searchParam, pagination: pagination})
      if (res.data.status === 1) {
        this.userSelect = res.data.data.content
      }
      else {
        this.userSelect = []
      }
    },
  },
  activated () {
    if (this.refresh) {
      this.$refs.dataTable.refresh()
    }
    /*this.getReservationConfig()*/
  },
  created () {
  }
}
</script>

<style scoped>

</style>
